import { render, staticRenderFns } from "./notice-list.vue?vue&type=template&id=535ff926&scoped=true&"
import script from "./notice-list.vue?vue&type=script&lang=js&"
export * from "./notice-list.vue?vue&type=script&lang=js&"
import style0 from "./notice-list.vue?vue&type=style&index=0&id=535ff926&prod&lang=scss&scoped=true&"
import style1 from "./notice-list.vue?vue&type=style&index=1&id=535ff926&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535ff926",
  null
  
)

export default component.exports